<template>
  <section class="BasicHeader">
    <div class="Header-details">
      <div style="display: flex;align-items: center; margin-right: 20px; height: 32px">
        <slot name="title">

        </slot>
      </div>
      <div class="u-flex-grow">
        <slot name="content">

        </slot>
      </div>
      <div>
        <slot name="tool">

        </slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Tool"
}
</script>

<style scoped>

.tool-title-h1 {
  font-size: 18px;
  font-family: "LatoLatinWeb", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bold;
  color: white;
  margin-top: 0px;
  margin-bottom: 0px;
}

.BasicHeader {
  background: #4a90e2;
  color: white;
}

.Header-details {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1800px;
  margin: 0 auto;
  padding: 20px 15px;
}

.u-flex-grow {
  flex-grow: 1;
  display: flex;
  align-items: center;
}


</style>
